import { render } from "./svg-component.vue?vue&type=template&id=c03e615c"
import script from "./svg-component.vue?vue&type=script&lang=js"
export * from "./svg-component.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__